import { ROUTES } from "../../../../module/constants";
import { generalConst } from "../../../../module/globalInterface";

export const CERTIFICATION_CONFIGURATIONS_MGMT_CONSOLE_ADMIN_URLS: generalConst =
  {
    BASE_URL: ROUTES.ADMIN_CERTIFICATION_CONFIGURATIONS_MGMT,
  };

export const STATE_IDENTIFIER = {
  CERTIFICATION_CONFIGURATIONS: "certificationConfigurations",
  LOADER_IDENTIFIER: "loader",
  LIST_IDENTIFIER: "list",
  SELECTED_CERTIFICATION: "selectedCertification",
  ENRICHMENT_SELECTED_CERTIFICATION: "enrichmentSelectedCertification",
};
